import { createContext } from 'react';
import { AuthContextType } from '../authTypes';

// Create the context with a default value
export const AuthContext = createContext<AuthContextType | null>(null);
